import { createContext } from 'react';
import { CalendarContextProps } from './Calendar.types';

// @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const CalendarContext = createContext<CalendarContextProps>(undefined);

export default CalendarContext;
